export default function (state = {
    transponder_timer: { search_string: '', list:{}, details:{}, validation:{}, options:{},list_pagination:{rpp:20,max_pages:0,total_rows:0,page:1}}
    }, action) {
    switch(action.type) {
        case 'TRANSPONDER_TIMER_UPDATE_SEARCH_STRING':
            state.transponder_timer.search_string = action.value;
            return { ...state };
        case 'TRANSPONDER_TIMER_SEARCH':
            state.transponder_timer.list = action.data.list;
            return { ...state };
        default:
            break;
    }
    return state;
}

